/**
 * VILLAPLUS — ASISTENTE INTELIGENTE (JS aislado)
 * No depende de villaplus-custom.js. Namespace: window.VillaplusAssistant
 * No usa librerías externas.
 */
(function () {
  'use strict';

  var TOTAL_STEPS = 7;

  /* Orden y etiquetas de los campos para el resumen (último paso) y el
     mensaje final de WhatsApp. Las claves coinciden con los name="" /
     data-vpa-field="" del .liquid. */
  var SUMMARY_FIELDS = [
    { key: 'marca', label: 'Marca' },
    { key: 'modelo', label: 'Modelo' },
    { key: 'tipo_asiento', label: 'Tipo de asiento' },
    { key: 'servicio', label: 'Trabajo solicitado' },
    { key: 'objetivo', label: 'Objetivo' },
    { key: 'entrega', label: 'Forma de entrega' },
    { key: 'direccion_cliente', label: 'Dirección' },
    { key: 'nombre', label: 'Nombre' },
    { key: 'whatsapp_cliente', label: 'WhatsApp' }
  ];

  /* Campos requeridos por paso. Los grupos de tarjetas (servicio,
     objetivo, entrega) validan que el input hidden tenga valor; el
     resto valida el input directamente. */
  var REQUIRED_BY_STEP = {
    1: ['marca', 'modelo'],
    2: ['tipo_asiento'],
    3: ['servicio'],
    4: ['objetivo'],
    5: ['entrega'],
    6: ['nombre', 'whatsapp_cliente']
  };

  function init(root) {
    var form = root.querySelector('[data-vpa-form]');
    if (!form) return;

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-vpa-step]'));
    var progressFill = root.querySelector('[data-vpa-progress-fill]');
    var progressWrap = root.querySelector('[data-vpa-progress-wrap]');
    var progressCurrent = root.querySelector('[data-vpa-progress-current]');
    var progressPercent = root.querySelector('[data-vpa-progress-percent]');
    var prevBtn = root.querySelector('[data-vpa-prev]');
    var nextBtn = root.querySelector('[data-vpa-next]');
    var whatsappNumber = (root.getAttribute('data-vpa-whatsapp') || '').replace(/\D/g, '');

    var currentStep = 1;

    /* -------------------------------------------------------------
       Ripple genérico para .vpa__card, .vpa__toggle, .vpa__nav-btn,
       .vpa__whatsapp-btn — se agrega on-click sin librerías.
       ----------------------------------------------------------- */
    function attachRipple(el) {
      el.addEventListener('click', function (e) {
        var rect = el.getBoundingClientRect();
        var size = Math.max(rect.width, rect.height);
        var ripple = document.createElement('span');
        ripple.className = 'vpa__ripple';
        ripple.style.width = ripple.style.height = size + 'px';
        ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
        ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';
        el.appendChild(ripple);
        window.setTimeout(function () { ripple.remove(); }, 650);
      });
    }
    root.querySelectorAll('.vpa__card, .vpa__toggle, .vpa__nav-btn, .vpa__whatsapp-btn').forEach(function (el) {
      el.style.position = el.style.position || 'relative';
      el.style.overflow = 'hidden';
      attachRipple(el);
    });

    /* -------------------------------------------------------------
       Validación por paso (declarada antes para que initSelectGroup
       pueda limpiar el estado inválido al seleccionar una tarjeta).
       ----------------------------------------------------------- */
    function clearInvalid(fieldEl) {
      var wrapper = fieldEl.closest('.vpa__field');
      if (wrapper) wrapper.classList.remove('is-invalid');
    }

    /* -------------------------------------------------------------
       Grupos de tarjetas seleccionables.
       - servicio / objetivo: selección MÚLTIPLE (checkbox),
         con tarjeta "Otro" que revela un campo de texto libre.
       - entrega: selección ÚNICA (radio), revela el bloque
         data-vpa-conditional que coincida con su data-vpa-reveals.
       ----------------------------------------------------------- */
    function initSelectGroup(groupName, isMulti) {
      var group = root.querySelector('[data-vpa-group="' + groupName + '"]');
      if (!group) return;
      var hiddenInput = form.querySelector('[data-vpa-field="' + groupName + '"]');
      var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-vpa-option]'));
      var otherField = form.querySelector('[data-vpa-other-field="' + groupName + '"]');
      var otherInput = otherField ? otherField.querySelector('[data-vpa-field]') : null;

      function syncHiddenValue() {
        if (!hiddenInput) return;
        var selected = buttons
          .filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })
          .map(function (b) {
            if (b.hasAttribute('data-vpa-other')) {
              var custom = otherInput ? (otherInput.value || '').trim() : '';
              return custom || b.getAttribute('data-vpa-value') || 'Otro';
            }
            return b.getAttribute('data-vpa-value');
          })
          .filter(Boolean);
        hiddenInput.value = selected.join(', ');
        if (selected.length) clearInvalid(hiddenInput);
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var isOther = btn.hasAttribute('data-vpa-other');

          if (isMulti) {
            var next = btn.getAttribute('aria-checked') !== 'true';
            btn.setAttribute('aria-checked', String(next));
          } else {
            buttons.forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
            btn.setAttribute('aria-checked', 'true');
          }

          if (otherField) {
            if (isMulti) {
              /* Selección múltiple: solo el propio botón "Otro" controla
                 si su campo se ve, según quede marcado o no. */
              if (isOther) {
                var showOther = btn.getAttribute('aria-checked') === 'true';
                otherField.hidden = !showOther;
                if (showOther && otherInput) otherInput.focus();
              }
            } else {
              /* Selección única: como solo puede haber una tarjeta
                 marcada, el campo se muestra si la recién elegida es la
                 de "Otro" y se oculta en cuanto se elige cualquier otra. */
              otherField.hidden = !isOther;
              if (isOther && otherInput) otherInput.focus();
            }
          }

          syncHiddenValue();

          /* Recomendación dinámica del paso 5 */
          if (groupName === 'objetivo' && btn.getAttribute('aria-checked') === 'true') {
            var box = root.querySelector('[data-vpa-recommendation-box]');
            var text = root.querySelector('[data-vpa-recommendation-text]');
            var rec = btn.getAttribute('data-vpa-recommendation');
            if (box && text && rec) {
              text.textContent = rec;
              box.hidden = false;
            }
          }

          /* Bloques condicionales (entrega personal/transportadora, y
             "¿en qué asiento?" al elegir una tarjeta de servicio como
             Hidrogel). Se revisa el estado real de TODO el grupo en vez
             de solo el botón recién tocado: en selección única (entrega)
             equivale a "el que quedó marcado", y en selección múltiple
             (servicio) el bloque se mantiene visible mientras CUALQUIER
             tarjeta marcada con ese mismo data-vpa-reveals siga
             seleccionada, y se oculta (y limpia) en cuanto se desmarca. */
          if (btn.hasAttribute('data-vpa-reveals')) {
            var seenReveals = {};
            buttons.forEach(function (b) {
              var id = b.getAttribute('data-vpa-reveals');
              if (id) seenReveals[id] = true;
            });
            Object.keys(seenReveals).forEach(function (id) {
              var anyChecked = buttons.some(function (b) {
                return b.getAttribute('data-vpa-reveals') === id && b.getAttribute('aria-checked') === 'true';
              });
              var panel = root.querySelector('[data-vpa-conditional="' + id + '"]');
              if (!panel) return;
              panel.hidden = !anyChecked;
              if (!anyChecked) {
                var innerHidden = panel.querySelector('input[type="hidden"]');
                if (innerHidden) innerHidden.value = '';
                panel.querySelectorAll('[data-vpa-option]').forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
              }
            });
          }
        });
      });

      if (otherInput) {
        otherInput.addEventListener('input', syncHiddenValue);
      }
    }
    initSelectGroup('marca', false);
    initSelectGroup('tipo_asiento', false);
    initSelectGroup('servicio', true);
    initSelectGroup('objetivo', true);
    initSelectGroup('entrega', false);
    initBrandModelHint();
    initSeatModal();

    /* -------------------------------------------------------------
       Paso 2: al elegir la marca, el placeholder de "Modelo" muestra
       ejemplos reales de ESA marca en vez de un texto genérico —
       la marca por sí sola no dice qué se espera escribir ahí.
       ----------------------------------------------------------- */
    function initBrandModelHint() {
      var group = root.querySelector('[data-vpa-group="marca"]');
      var modeloInput = form.querySelector('[data-vpa-modelo-input]');
      if (!group || !modeloInput) return;

      var defaultPlaceholder = modeloInput.getAttribute('placeholder') || '';
      var examples = {
        'Suzuki': 'Ej: GN 125, GSX-S 150, AX4',
        'Yamaha': 'Ej: FZ 25, MT-03, XTZ 150',
        'Honda': 'Ej: CB190R, XR150L, Biz 125',
        'AKT': 'Ej: NKD 125, CR4, Flex',
        'Bajaj': 'Ej: Boxer, Discover 125, Dominar 400',
        'AUTECO': 'Ej: Kawasaki KLX, Eliminator',
        'Hero': 'Ej: Hunk, Splendor, Ignitor',
        'Victory': 'Ej: Octane, Vegas, Hammer',
        'KYMCO': 'Ej: Agility 125, Like 150',
        'KTM': 'Ej: Duke 200, RC 390, Adventure 390',
        'BMW': 'Ej: G 310 R, F 850 GS',
        'Pulsar': 'Ej: NS 200, 135 LS, 180',
        'Eléctrica': 'Ej: marca y modelo de tu moto eléctrica',
        'Otra': 'Ej: escribe el modelo'
      };

      group.querySelectorAll('[data-vpa-option]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var value = btn.getAttribute('data-vpa-value');
          modeloInput.setAttribute('placeholder', examples[value] || defaultPlaceholder);
        });
      });
    }

    /* -------------------------------------------------------------
       Pop-up "¿En qué asiento?" — uno por cada tarjeta de servicio con
       data-vpa-seat-trigger que el cliente vaya marcando (Paso 3). Se
       abren de a uno: si marca varios a la vez, se encolan y aparecen
       en fila apenas se cierra el anterior. Cada servicio guarda su
       propia respuesta en un campo oculto independiente (creado aquí
       mismo dentro de [data-vpa-seat-fields]), así que dos servicios
       distintos pueden tener asientos distintos.
       ----------------------------------------------------------- */
    function initSeatModal() {
      var modal = root.querySelector('[data-vpa-seat-modal]');
      var fieldsContainer = root.querySelector('[data-vpa-seat-fields]');
      var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-vpa-seat-trigger]'));
      if (!modal || !fieldsContainer || !triggers.length) return;

      var subtitleEl = modal.querySelector('[data-vpa-seat-modal-subtitle]');
      var optionBtns = Array.prototype.slice.call(modal.querySelectorAll('[data-vpa-modal-option]'));
      var closeEls = Array.prototype.slice.call(modal.querySelectorAll('[data-vpa-seat-modal-close]'));

      var queue = [];
      var currentLabel = null;

      function fieldKey(label) {
        var slug = label
          .toLowerCase()
          .replace(/[áàäâ]/g, 'a')
          .replace(/[éèëê]/g, 'e')
          .replace(/[íìïî]/g, 'i')
          .replace(/[óòöô]/g, 'o')
          .replace(/[úùüû]/g, 'u')
          .replace(/ñ/g, 'n')
          .replace(/[^a-z0-9]+/g, '_')
          .replace(/^_+|_+$/g, '');
        return 'asiento_servicio_' + slug;
      }

      function getField(label, create) {
        var key = fieldKey(label);
        var field = fieldsContainer.querySelector('[data-vpa-seat-key="' + key + '"]');
        if (!field && create) {
          field = document.createElement('input');
          field.type = 'hidden';
          field.setAttribute('data-vpa-seat-key', key);
          field.setAttribute('data-vpa-seat-label', label);
          field.setAttribute('data-vpa-field', key);
          fieldsContainer.appendChild(field);
        }
        return field;
      }

      function closeModalUI() {
        modal.hidden = true;
        document.body.style.overflow = '';
      }

      /* Muestra/oculta en la propia tarjeta de servicio el asiento que
         se eligió para ella, para que el cliente vea la confirmación
         apenas se cierra el pop-up, sin tener que reabrirlo. */
      function updateBadge(label, value) {
        var trigger = triggers.filter(function (t) {
          return t.getAttribute('data-vpa-seat-label') === label;
        })[0];
        var badge = trigger ? trigger.querySelector('[data-vpa-seat-badge]') : null;
        if (!badge) return;
        if (value) {
          badge.textContent = value;
          badge.hidden = false;
        } else {
          badge.textContent = '';
          badge.hidden = true;
        }
      }

      function openNext() {
        if (!queue.length) { currentLabel = null; return; }
        currentLabel = queue.shift();
        var existing = getField(currentLabel, false);
        optionBtns.forEach(function (b) {
          b.setAttribute('aria-checked', existing && existing.value === b.getAttribute('data-vpa-value') ? 'true' : 'false');
        });
        if (subtitleEl) subtitleEl.textContent = currentLabel;
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      }

      triggers.forEach(function (btn) {
        btn.addEventListener('click', function () {
          /* El pop-up "¿En qué asiento?" solo tiene sentido si el
             asiento es Dividido (piloto/parrillero por separado). Si el
             cliente eligió "Asiento Completo" (o aún no ha contestado),
             se omite — salvo que la tarjeta tenga marcado "preguntar
             siempre" (ej. Hidrogel, donde la pregunta es sobre en qué
             parte del asiento aplicar el gel, no sobre cuál asiento
             físico, así que sigue aplicando aunque sea de una pieza).
             La tarjeta se deja marcada normalmente en cualquier caso
             (lo maneja el selector general del Paso 3). */
          var alwaysAsk = btn.hasAttribute('data-vpa-always-ask-seat');
          if (!alwaysAsk && getFieldValue('tipo_asiento') !== 'Asiento Dividido') {
            return;
          }

          var label = btn.getAttribute('data-vpa-seat-label');
          var isChecked = btn.getAttribute('aria-checked') === 'true';

          if (isChecked) {
            if (currentLabel !== label && queue.indexOf(label) === -1) {
              queue.push(label);
            }
            /* Breve pausa antes de abrir: deja que el cliente VEA el
               check quedar puesto en la tarjeta antes de que el pop-up
               le tape la pantalla. Lo suficientemente corta para que
               el pop-up se sienta inmediato, no lento. */
            if (modal.hidden) window.setTimeout(openNext, 90);
          } else {
            var idx = queue.indexOf(label);
            if (idx !== -1) queue.splice(idx, 1);
            var field = getField(label, false);
            if (field) field.remove();
            updateBadge(label, null);
            if (currentLabel === label) {
              closeModalUI();
              currentLabel = null;
              window.setTimeout(openNext, 100);
            }
          }
        });
      });

      optionBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          optionBtns.forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
          b.setAttribute('aria-checked', 'true');
          if (currentLabel) {
            var field = getField(currentLabel, true);
            field.value = b.getAttribute('data-vpa-value');
            updateBadge(currentLabel, field.value);
          }
          closeModalUI();
          window.setTimeout(openNext, 120);
        });
      });

      closeEls.forEach(function (el) {
        el.addEventListener('click', function () {
          closeModalUI();
          window.setTimeout(openNext, 100);
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) {
          closeModalUI();
          window.setTimeout(openNext, 100);
        }
      });
    }

    /* -------------------------------------------------------------
       Validación por paso
       ----------------------------------------------------------- */
    function validateStep(stepNumber) {
      var requiredKeys = REQUIRED_BY_STEP[stepNumber];
      if (!requiredKeys) return true;

      var firstInvalid = null;
      requiredKeys.forEach(function (key) {
        var field = form.querySelector('[data-vpa-field="' + key + '"]');
        if (!field) return;
        var value = (field.value || '').trim();
        var wrapper = field.closest('.vpa__field');
        if (!value) {
          if (wrapper) {
            wrapper.classList.remove('is-invalid');
            // Forzar reflow para poder relanzar la animación de shake
            void wrapper.offsetWidth;
            wrapper.classList.add('is-invalid');
          }
          if (!firstInvalid) firstInvalid = field;
        } else if (wrapper) {
          wrapper.classList.remove('is-invalid');
        }
      });

      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      return true;
    }

    /* -------------------------------------------------------------
       Navegación entre pasos
       ----------------------------------------------------------- */
    function updateProgress() {
      var pct = (currentStep / TOTAL_STEPS) * 100;
      if (progressFill) progressFill.style.width = pct + '%';
      if (progressWrap) progressWrap.setAttribute('aria-valuenow', currentStep);
      if (progressCurrent) progressCurrent.textContent = currentStep;
      if (progressPercent) progressPercent.textContent = Math.round(pct);
    }

    function updateNavButtons() {
      if (prevBtn) prevBtn.hidden = currentStep === 1;
      if (nextBtn) nextBtn.hidden = currentStep === TOTAL_STEPS;
    }

    function goToStep(targetStep, direction) {
      if (targetStep < 1 || targetStep > TOTAL_STEPS) return;
      var currentEl = steps[currentStep - 1];
      var targetEl = steps[targetStep - 1];
      if (!currentEl || !targetEl) return;

      var outClass = direction === 'back' ? 'is-leaving-right' : 'is-leaving-left';
      currentEl.classList.remove('is-active');
      currentEl.classList.add(outClass);

      window.setTimeout(function () {
        currentEl.classList.remove(outClass);
        targetEl.classList.add('is-active');
        currentStep = targetStep;
        updateProgress();
        updateNavButtons();
        if (currentStep === TOTAL_STEPS) renderSummary();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 180);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!validateStep(currentStep)) return;
        goToStep(currentStep + 1, 'forward');
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToStep(currentStep - 1, 'back');
      });
    }

    /* -------------------------------------------------------------
       Resumen (último paso)
       ----------------------------------------------------------- */
    function getFieldValue(key) {
      var field = form.querySelector('[data-vpa-field="' + key + '"]');
      return field ? (field.value || '').trim() : '';
    }

    /* Respuestas de "¿en qué asiento?" guardadas por servicio (una por
       cada tarjeta con data-vpa-seat-trigger que el cliente haya
       marcado y respondido en el pop-up). */
    function getSeatAnswers() {
      var container = root.querySelector('[data-vpa-seat-fields]');
      if (!container) return [];
      return Array.prototype.slice.call(container.querySelectorAll('[data-vpa-seat-label]'))
        .filter(function (f) { return (f.value || '').trim(); })
        .map(function (f) { return { label: f.getAttribute('data-vpa-seat-label'), value: f.value.trim() }; });
    }

    function renderSummary() {
      var summaryEl = root.querySelector('[data-vpa-summary]');
      if (!summaryEl) return;
      summaryEl.innerHTML = '';

      function addRow(label, value) {
        if (!value) return;
        var row = document.createElement('div');
        row.className = 'vpa__summary-row';
        var dt = document.createElement('dt');
        dt.textContent = label;
        var dd = document.createElement('dd');
        dd.textContent = value;
        row.appendChild(dt);
        row.appendChild(dd);
        summaryEl.appendChild(row);
      }

      SUMMARY_FIELDS.forEach(function (item) {
        addRow(item.label, getFieldValue(item.key));
        if (item.key === 'servicio') {
          getSeatAnswers().forEach(function (seat) {
            addRow('Asiento — ' + seat.label, seat.value);
          });
        }
      });
    }

    /* -------------------------------------------------------------
       Mensaje final de WhatsApp
       ----------------------------------------------------------- */
    function buildWhatsAppMessage() {
      var lines = [];
      lines.push('Hola, mi nombre es ' + (getFieldValue('nombre') || '—') + '.');
      lines.push('Quiero cotizar un tapizado.');
      lines.push('');
      lines.push('Marca:');
      lines.push(getFieldValue('marca') || '—');
      lines.push('');
      lines.push('Modelo:');
      lines.push(getFieldValue('modelo') || '—');
      lines.push('');
      lines.push('Tipo de asiento:');
      lines.push(getFieldValue('tipo_asiento') || '—');
      lines.push('');
      lines.push('Trabajo solicitado:');
      lines.push(getFieldValue('servicio') || '—');
      lines.push('');
      getSeatAnswers().forEach(function (seat) {
        lines.push('Asiento (' + seat.label + '):');
        lines.push(seat.value);
        lines.push('');
      });
      lines.push('Objetivo:');
      lines.push(getFieldValue('objetivo') || '—');
      lines.push('');
      lines.push('Forma de entrega:');
      var entregaTexto = getFieldValue('entrega') || '—';
      var direccionCliente = getFieldValue('direccion_cliente');
      if (direccionCliente) entregaTexto += ' (' + direccionCliente + ')';
      lines.push(entregaTexto);
      lines.push('');
      lines.push('WhatsApp:');
      lines.push(getFieldValue('whatsapp_cliente') || '—');
      lines.push('');
      lines.push('Quedo atento a la cotización.');
      return lines.join('\n');
    }

    var submitBtn = root.querySelector('[data-vpa-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var message = buildWhatsAppMessage();
        var url = 'https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(message);
        window.open(url, '_blank', 'noopener');
      });
    }

    /* Estado inicial */
    updateProgress();
    updateNavButtons();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-vpa]').forEach(init);
  });

  window.VillaplusAssistant = { init: init };
})();
